import { render, staticRenderFns } from "./CoozzyFilterIcon.vue?vue&type=template&id=270a910b&scoped=true"
import script from "./CoozzyFilterIcon.vue?vue&type=script&lang=js"
export * from "./CoozzyFilterIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "270a910b",
  null
  
)

export default component.exports